// lightbox2 has flow of register -> check -> cardUpdate 


import React, { Component } from 'react';
import { connect } from 'react-redux';
import card from '../../images/icons/ico_cc_def.png';
import cardVisa from '../../images/icons/ico_cc_visa.png';
import {withTranslation} from 'react-i18next'
import { PAYMENT_GATEWAY, CARD_CAN_BE_CHARGED, DEMO, CARD_DEMO, CMSPath, DEV_IP } from '../../../config/constant';
import Loader from '../../UI/loader';
import clientConfigApi from '../../../config/config';
import {setCardStatusPopupProps, setCheckinCurrentPageName} from '../../action/autoCheckin';
import { popupOpenClose, setCheckInAddress } from "../../../action/action";
import { sendAnalytics } from "../../../action/homeAction"
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import $ from "jquery";
import { AvsCodes, cardValidationIntermediaryEvents } from './helper';

const validateResultMessage = (response, status, cardValidationAvsEnabled = false )=> {
    if(!cardValidationAvsEnabled){
        return status;
    }

    if(status == "approved" && response.ssl_result_message != "APPROVAL") return "ssl_result_not_approved";

    return status;
}

class AddCard extends Component{

    constructor(props){
        super(props)
        this.state = {
            showLoader: false,
            cardNumber: "",
            expiryDate: "",
            sessionToken: localStorage.getItem("GuestJourneySessionToken"),
            cvv: "",
            address: "",
            zip: "",
            firstName: "",
            lastName: "",
            formattedCardNumber: "",
            cardVerified: false
        }

        this.handleMessageEvent = this.handleMessageEvent.bind(this);
        window.addEventListener("message", this.handleMessageEvent);
    }

    elavonCallback(response, status, confirmationNumber, userInfo){
        console.log("Callback from elavon", status, response);
        $(".lightbox-iframe-container").attr("style", "")

            try {

                this.setState({showLightBoxPage: false})
                this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.GOT_PAYMENT_GATEWAY_RESPONSE, response)

                const updatedStatus =  validateResultMessage(response, status, this.props.cardChecksData.cardValidationAvsEnabled);

                switch(status){
                    case "declined":
                        // PAYMENT_GATEWAY_RESPONSE_DECLINED
                        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.PAYMENT_GATEWAY_RESPONSE_DECLINED, response )
                        break;
                    case "error":
                        // PAYMENT_GATEWAY_RESPONSE_ERROR
                        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.PAYMENT_GATEWAY_RESPONSE_ERROR, response )

                        break;
                    case "cancelled":
                        // PAYMENT_GATEWAY_RESPONSE_CANCELLED
                        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.PAYMENT_GATEWAY_RESPONSE_CANCELLED, response )

                        break;
                    case "approved":
                        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.PAYMENT_GATEWAY_RESPONSE_APPROVED, response )
                        if( this.props.cardChecksData.cardValidationAvsEnabled){
                            switch(updatedStatus){
                                case "ssl_result_not_approved":
                                    this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.INTERNAL_CHECK_IF_SSL_RESULT_APPROVED_FAILED, response );
                                    break;
                                case "approved":
                                    this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.INTERNAL_CHECK_IF_SSL_RESULT_APPROVED_SUCCESS, response );
                                    break;
                            }
                        }   

                        break;
                }

                clientConfigApi.post("/mobileCheckIn/cardValidation", {
                    "header": {
                        "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                        "actionKey": "checks"
                    },
                    "payload": {
                        "confirmationNumber": confirmationNumber,
                        "lastNameCard": response && response.ssl_last_name,
                        "cardDigits":  response && response.ssl_card_number ? response.ssl_card_number.slice(12,17) : undefined,
                        "cardFullName":response &&  response.ssl_first_name &&  response.ssl_last_name ?  response.ssl_first_name + " " + response.ssl_last_name :undefined,
                        "raw_response":response
                    }
                })
                .then((resp)=>{
                    if (resp.status == 200) {
                                
                                if(updatedStatus == "approved"){
                                    this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CHECKS_API_SUCCESS, response )

                                    this.props.showLoader(true);

                                    clientConfigApi.post("/mobileCheckIn/cardValidation", {
                                        "header": {
                                        "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                                        "actionKey":"cardUpdate"
                                        },
                                        "payload": {
                                            "confirmationNumber": confirmationNumber,
                                            "cardDigits": response.ssl_card_number.slice(12,17),//this.state.cardNumber.slice(-this.props.cardChecksData.cardNumberOfDigits,this.state.cardNumber.length),
                                            "firstNameCard": response.ssl_first_name,
                                            "lastNameCard": response.ssl_last_name,
                                            "cardCheckId":response.ssl_partner_app_id,
                                            "transactionType": this.props.cardChecksData.cardValidationAvsEnabled ? "ccgettoken" : "ccverify" ,
                                            "reservationNumber":response.ssl_transaction_reference_number, // 383244512326
                                            "vaultedCardId":response.ssl_token,
                                            "cardTypeCode": response.ssl_card_short_description,
                                            "expiryDate":response.ssl_exp_date
                                        }
                                    })
                                    .then((res) => {

                                        
                                        this.setState({cardVerified: true});
                                        this.props.setcardVerified(true, response.ssl_token);
                                        this.props.showFailScreen(false);
                                        this.props.showLoader(false);
                                        this.props.setCardStatusPopupProps({
                                            cardStatus: true,
                                            statusTitle: 'Success',
                                            statusMessage1: 'Card verified successfully',
                                            statusMessage2: 'Please proceed to next steps'
                                        })
                                        this.props.showCardVerified(userInfo)
                                        localStorage.setItem("cardVerfied", true)
                                        console.log("ssl_token", response.ssl_token, response)

                                        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CARD_UPDATE_API_SUCCESS , response )

                                        this.sendTheAnalytics(true, response, updatedStatus, "", "CardUpdate call is successful")

                                    })
                                    .catch((err) => {
                                        this.props.showFailScreen(true, "Unable to update card in the reservation. Please contact Front Desk");
                                        this.props.showLoader(false);

                                        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CARD_UPDATE_API_FAILED , response , {
                                            errorMessage:   err && err.response && err.response.data && err.response.data.header && err.response.data.header.status && err.response.data.header.status.msg
                                        })

                                        // Send Analytics
                                        let failedReason = "Unable to update card in the reservation.";
                                        this.sendTheAnalytics(false, response, updatedStatus, failedReason, "cardUpdate call failed. From catch block")


                                        if(window.FirebasePlugin){
                                            window.FirebasePlugin.logError("Unable to update card in the reservation.", err)
                                        }
                                    })


                                } else {

                                    let failureReasonToDisplay ;

                                    switch(updatedStatus){
                                        case "declined":
                                            // PAYMENT_GATEWAY_RESPONSE_DECLINED
                                            failureReasonToDisplay = response.ssl_result_message;
                                            break;
                                        case "error":
                                            // PAYMENT_GATEWAY_RESPONSE_ERROR
                                            failureReasonToDisplay = response;
                                            break;
                                        case "cancelled":
                                            // PAYMENT_GATEWAY_RESPONSE_CANCELLED
                                            failureReasonToDisplay = "Card validation cancelled";
                                            break;
                                        case "ssl_result_not_approved":
                                            
                                            failureReasonToDisplay = "Transaction could not be approved.";
                                            break;
                                    }


                            
                                    this.props.showFailScreen(true, failureReasonToDisplay );
                                    this.props.showLoader(false);
                                    
                    

                                    // Send Analytics
                                    let failedReason = response.ssl_result_message;
                                    this.sendTheAnalytics(false, response, updatedStatus, failedReason, "Checks call passed. But Elavon response status was not approved")

                            }
                    } else{
                        this.props.showFailScreen(true, resp.data && resp.data.header && resp.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");
                        this.props.showLoader(false);

                        // Send Analytics
                        let failedReason = resp.data && resp.data.header && resp.data.header.status.msg || "Unable to check card for the reservation. Please try again or contact Front Desk";
                        
                        if(updatedStatus == "approved"){
                            this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CHECKS_API_FAILED, response, {
                                errorMessage: resp && resp.data && resp.data.header && resp.data.header.status && resp.data.header.status.msg 
                            })
                        }
                        
                        this.sendTheAnalytics(false, response, status, failedReason, "Checks call failed. From else block")

                    }
                })
                .catch((err)=>{
                    
                        this.props.showFailScreen(true,  err.response && err.response.data && err.response.data.header && err.response.data.header.status.msg || "Unable to check card for the reservation. Please try again or contact Front Desk");
                        this.props.showLoader(false);

                        let failedReason = err.response && err.response.data && err.response.data.header && err.response.data.header.status.msg  ;

                        if(updatedStatus == "approved"){
                            this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CHECKS_API_FAILED, response, {
                                errorMessage:failedReason
                            })
                        }

                        // Send Analytics
                        this.sendTheAnalytics(false, response, status, failedReason, "Checks call failed, in catch block")

                })      
            } catch (e) {
                console.log("error while calling callback from elavon", e);
                if(window.FireBasePlugin){
                    window.FirebasePlugin.logError("error while calling callback from elavon" + e)
                }
            }
        };

    sendIntermediaryCardValidationGA = (subAction, responseFromElavon = {}, additionalFields = {} )=>{
        // "cardCode": elavonResponse.ssl_card_short_description,
        // "ssl_avs_response": elavonResponse && elavonResponse.ssl_avs_response ? elavonResponse.ssl_avs_response :"",
        // "cardStatus":elavonResponseStatus,
        // "errorMessage": failedReason ,
        // "additionalComment": additionalComment,
    
        let label = {
            "subAction":subAction,
            ...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
            "dateTime": new Date,
            "layoutTab": this.props.currentHomePage.tabName,
            "pageName": "CREDIT CARD DETAILS",
            "widgetSessionId": localStorage.getItem("checkinSessionToken"),
            sslCard : responseFromElavon && responseFromElavon.ssl_card_short_description ? responseFromElavon.ssl_card_short_description: undefined ,
            sslResultMessage  : responseFromElavon && responseFromElavon.ssl_result_message ? responseFromElavon.ssl_result_message: undefined,
            sslAvsResponse  : responseFromElavon && responseFromElavon.ssl_avs_response ? responseFromElavon.ssl_avs_response : undefined,
            sslTokenResponse  :   responseFromElavon && responseFromElavon.ssl_token_response ? responseFromElavon.ssl_token_response : undefined,
            sslAvsResponseCodeDescription: responseFromElavon && responseFromElavon.ssl_avs_response ? AvsCodes[responseFromElavon.ssl_avs_response] : undefined,
            ...additionalFields
        }

        this.props.sendAnalytics(
            null, 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "CREDIT CARD DETAILS - IN PROGRESS", 
            label, 
            0, 
            false
        );
    
    }
    
    sendTheAnalytics = (isCardValidationSuccess, elavonResponse, elavonResponseStatus, failedReason, additionalComment ) => {

                        let label = {
                            "cardCode": elavonResponse && elavonResponse.ssl_card_short_description,
                            "ssl_avs_response": elavonResponse && elavonResponse.ssl_avs_response ? elavonResponse.ssl_avs_response :"",
                            "cardStatus":elavonResponseStatus,
                            "dateTime": new Date,
                            "errorMessage": failedReason ,
                            "additionalComment": additionalComment,
                            "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                            "Room": localStorage.getItem("room") || "",
                            "sourceApp": "guestJourneyApp",
                            "layoutTab": this.props.currentHomePage.tabName,
                            "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                        }

                        this.props.sendAnalytics(
                        null, 
                        this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                        isCardValidationSuccess ? "CREDIT CARD DETAILS - SUCCESS" : "CREDIT CARD DETAILS - FAILED", 
                        label, 
                        0, 
                        false
                        );
    }

    handleMessageEvent(e) {
        try {
            if (e.data && JSON.parse(e.data) && JSON.parse(e.data).status) {
                this.elavonCallback(JSON.parse(e.data).response, JSON.parse(e.data).status, this.props.confirmationNumber, {firstName: this.state.firstName, lastName: this.state.lastName});
            }   
        } catch (error) {
            console.log("error handling message eventlistener")
        }
    }

    confirmCardWithPMS = () => {

        if(!this.state.firstName){
            this.props.popupOpenClose(true, "Please enter your first name");
            return;
        }
        if(!this.state.lastName){
            this.props.popupOpenClose(true, "Please enter your last name");
            return;
        }

        if(!this.state.address || this.state.address == ""){
            this.props.popupOpenClose(true, "Please enter your address");
            return;
        }

        if(!this.state.zip || this.state.zip == ""){
            this.props.popupOpenClose(true, "Please enter your postal code");
            return;
        }

        if(!(/^[a-zA-Z0-9, .]+$/.test(this.state.address))){
            this.props.popupOpenClose(true, "Please note that only English letters and numbers are accepted for the address")
            return;
        }

        this.props.setCheckInAddress({...this.props.checkInAddress, addressLine1: this.state.address, postalCode: this.state.zip})

        if(CARD_DEMO){
            this.props.showLoader(true);
            setTimeout(() => {
                this.props.showLoader(false);
                this.setState({cardVerified: true})
                this.props.setCardStatusPopupProps({
                    cardStatus: true,
                    statusTitle: 'Success',
                    statusMessage1: 'Card verified successfully',
                    statusMessage2: 'Please proceed to next steps'
                })
                this.props.showCardVerified({firstName: this.state.firstName, lastName: this.state.lastName})
                localStorage.setItem('cardVerfied', true)

                let label = {
                    "dateTime": new Date,
                    "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                    "Room": localStorage.getItem("room") || "",
                    "sourceApp": "guestJourneyApp",
                    "layoutTab": this.props.currentHomePage.tabName,
                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                }
                this.props.sendAnalytics(
                    null, 
                    this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                    "CREDIT CARD DETAILS - SUCCESS", 
                    label, 
                    0, 
                    false
                );
                
            }, 1500)
            return;
        }

        // this.props.showLoader(true);
        this.setState({showLoader: true})

        clientConfigApi.post("/mobileCheckIn/cardValidation", {
            "header": {
              "sessionToken": this.state.sessionToken,
              "actionKey":"register"
            },
            "payload": {
                "confirmationNumber": this.props.confirmationNumber,
                "cardDigits": "",//this.state.cardNumber.slice(-this.props.cardChecksData.cardNumberOfDigits,this.state.cardNumber.length),
                "firstNameCard": this.state.firstName,
                "lastNameCard": this.state.lastName,
                "transactionType": this.props.cardChecksData.cardValidationAvsEnabled ? "ccgettoken" : "ccverify"
            }
          }).then(response => {
                // this.setState({showLoader: false})
                if(response.data.payload.merchantId && response.data.payload.tokenStr){
                    // this.pay(response.data.payload.merchantId, response.data.payload.tokenStr);
                    this.setState({showLightBoxPage: true, paymentToken: response.data.payload.tokenStr, merchantId: response.data.payload.merchantId})
                    this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.REGISTER_API_SUCCESS)
                }
                else{
                    this.setState({showLoader: false});
                    this.props.showFailScreen(true, response.data && response.data.header && response.data.header.status.msg || "Card verification failed");
                    if(window.FirebasePlugin){
                        window.FirebasePlugin.logError("Card validation api failed CMS: ", response.data.header.status.msg )
                    }
                    // Send Analytics
                    let failedReason = response.data && response.data.header && response.data.header.status.msg || "Card verification failed"
                    let label = {...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
                                    "dateTime": new Date,
                                    "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                }
                    this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.REGISTER_API_FAILED, null, { "errorMessage": response && response.data && response.data.header && response.data.header.status && response.data.header.status.msg})
                    this.props.sendAnalytics(
                        null, 
                        this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                        "CREDIT CARD DETAILS - FAILED", 
                        label, 
                        0, 
                        false
                    );
                    //
                }

          }).catch(response => {
            this.setState({showLoader: false})
                this.props.showFailScreen(true, response.data && response.data.header && response.data.header.status.msg || "Card verification failed");
                if(window.FirebasePlugin){
                    window.FirebasePlugin.logError("Card validation api failed CMS: ", response.data.header.status.msg )
                }
                // Send Analytics
                let failedReason = response.data && response.data.header && response.data.header.status.msg || "Card verification failed"
                let label = {...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
                                "dateTime": new Date,
                                "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                                "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                            }

                this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.REGISTER_API_FAILED, null, { "errorMessage": response && response.data && response.data.header && response.data.header.status && response.data.header.status.msg})
                this.props.sendAnalytics(
                        null, 
                        this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
                        "CREDIT CARD DETAILS - FAILED", 
                        label, 
                        0, 
                        false
                    );
                //
          });
    }


    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessageEvent);
    }

    componentDidMount() {

        this.setState({
            firstName: this.props.firstName,
            lastName: this.props.lastName,
            address: this.props.checkInAddress.addressLine1,
            zip: this.props.checkInAddress.postalCode
        })
        this.props.setCheckinCurrentPageName("CREDIT CARD DETAILS")

        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.LANDED_ON_CARD_DETAILS_PAGE)
    }

    render(){
        const {t} = this.props
        return(
            <div className='lightbox-iframe-container'>
                {this.state.showLightBoxPage 
                ? <iframe frameborder="0" onLoad={() => {
                    $(".lightbox-container").attr("style", "width: 100%; height: 100%")
                    $(".lightbox-iframe-container").attr("style", "position: absolute; top: 0; left: 0; width: 100vw; height: 100vh; background: #fff")
                    this.setState({showLoader: false})
                }} style={{width: 0, height: 0}} className='lightbox-container' src={ !DEMO ? `https://guest-journey.s3.amazonaws.com/static/lightbox.html?isSslVerifyEnabled=${this.props.cardChecksData.cardValidationAvsEnabled ? true :false }&token=${this.state.paymentToken}&address=${this.state.address}&zip=${this.state.zip}` : `http://${DEV_IP}:8080/cmsData/elavon/lightbox.html?token=${this.state.paymentToken}&address=${this.state.address}&zip=${this.state.zip}` }></iframe> 
                : <div>
                    <header className="inner-pages w-footer subpages">
                    <a className="button-back" onClick = {this.props.backBtn}></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style = {{color:"inherit"}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section className="widgets padding-0 margin-0 container-bg">

                <div class="widget-header widget-header-checkin-inner card-validation">
                    { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                        </div>
                    }

                    {
                        process.env.REACT_APP_NEWER_DESIGN=="true" 
                        ?
                        <>
                            <div class="widget-header-title">{t("check_in.verify_card_heading")}</div>
                              <div class="widget-header-subtitle">{t("check_in.verify_card_subheading")}</div>
                        </>
                        :
                        <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div> 

                    }
                     </div>

                    <div className="widgets">
                        <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                            <h2>{t('check_in.booking_details')}</h2>
                        </div>
                        {  !(localStorage.getItem('cardVerfied') == 'true') ?
                            <div className="form-window">
                                <div className="form-window-heading">
                                {t('check_in.card_details')}
                                </div>
                                <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                    <p>{ CARD_CAN_BE_CHARGED ? t('check_in.enter_card_details') : "Please enter your card details."} </p>
                                    <div>
                                        <div className="form-row margin-bottom-1 margin-right-1">
                                            <label for="firstName">First Name <span style={{color:"red"}}>*</span></label>
                                            <input 
                                                name="firstName" 
                                                autoComplete='given-name' 
                                                onChange={(e) => this.setState({firstName: e.target.value})} 
                                                value={this.state.firstName}
                                                type="text" 
                                                placeholder="First Name" />
                                        </div>
                                        <div className="form-row margin-bottom-1 margin-right-1">
                                            <label for="lastName">Last Name <span style={{color:"red"}}>*</span></label>
                                            <input 
                                                name="lastName" 
                                                autoComplete='family-name' 
                                                onChange={(e) => this.setState({lastName: e.target.value})} 
                                                value={this.state.lastName}
                                                type="text" 
                                                placeholder="Last Name" />
                                        </div>
                                        <div className="form-row margin-bottom-1 margin-right-1">
                                            <label for="address">Address <span style={{color:"red"}}>*</span></label> 
                                            <input 
                                                name="address" 
                                                autoComplete='address-line1'
                                                onChange={(e) => this.setState({address: e.target.value})} 
                                                value={this.state.address}
                                                placeholder="Street Name and Number"
                                                type="text" />
                                        </div>
                                        <div className="form-row margin-bottom-1 margin-right-1">
                                            <label for="postalCode">Postal Code <span style={{color:"red"}}>*</span></label>
                                            <input 
                                                name="postalCode"
                                                autoComplete='postal-code' 
                                                onChange={(e) => this.setState({zip: e.target.value})} 
                                                value={this.state.zip}
                                                placeholder="Postal Code"
                                                />
                                        </div>
                                    </div>
                                    
                                    <div className="form-controls">
                                        <button disabled={this.state.cardVerified} className="primary w-100" onClick = {this.confirmCardWithPMS}>Verify Card</button>
                                    </div>
                                    {DEMO && <input class="card-skip" onClick={() => this.props.next({firstName: this.state.firstName, lastName: this.state.lastName})} type="submit" value="Skip" style={{marginTop: '1rem', color: "#000", backgroundColor: "#fff"}}/>}
                                </div>
                            </div>
                        :
                            <div class="form-window">
                                <div class="form-window-heading">
                                    Card verified
                                </div>
                                <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                    <div class="form-row margin-bottom-1">
                                    <p>Your card was successfully verified.</p> {/* **** **** **** 4242  */}
                                        <p>Tap on NEXT to proceed</p> 
                                    </div>
                                    <div class="form-controls">
                                        {/* <button class="secondary w-100 margin-bottom-1">Change card</button>  */}
                                        <button className="primary w-100" onClick = {() => this.props.next({firstName: this.state.firstName, lastName: this.state.lastName})}>{t('check_in.next')}</button>
                                    </div>
                                </div>
                            </div>
                        }    
                    </div>
                </section>
            </div>}
            { this.state.showLoader && <Loader close={() => this.setState({showLoader: false})} displayMsg="Verifying data..." />}
        </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        cardChecksData: state.store2.cardChecksData, 
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        checkInAddress : state.store2.checkInAddress
    }
}

export default connect(mapStateToProps,{
    setCardStatusPopupProps,
    popupOpenClose,
    sendAnalytics,
    setCheckInAddress,
    setCheckinCurrentPageName
   })(withTranslation('translations')(AddCard));